export default "__VITE_ASSET__CTzAgt56__"